<script>
import {
    getContext
} from 'svelte';
const {
    data,
    xGet,
    yGet
} = getContext('LayerCake');
import {makeSVGpathCurved} from "../../../utils/BezierConverter";

export let stroke = '#D8002B';
export let strokeWidth = 3;

	$: pathCurved = () => {
		let tempList = [];
		$data[1].values
			.map(d => {
				tempList.push([$xGet(d) , $yGet(d)]);
			})	
			return makeSVGpathCurved(tempList);
	}

</script>

<path class='path-line' style={'stroke-width: ' + strokeWidth} d='{pathCurved()}' {stroke}></path>

<style>
.path-line {
    fill: none;
    stroke-linejoin: round;
    stroke-linecap: round;
}
</style>
